import { contractDate } from './planningDates';

export function frenchDate(value) {
  const french = String(value ?? '').match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  const date = value instanceof Date ? value : contractDate(french ? `${french[3]}-${french[2]}-${french[1]}` : value);
  return date && !Number.isNaN(date.getTime()) ? date.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" }) : '—';
}
